export default (duration = 3000) => ({
    endValue: 0,
    startValue: 0,
    duration,
    startTime: null,
    cubicOut(t) {
        const f = t - 1.0;
        return f * f * f + 1.0;
    },
    update() {
        const currentTime = performance.now();
        const elapsedTime = currentTime - this.startTime;
        const progress = Math.min(1, elapsedTime / this.duration);

        let currentValue;
        if (Number.isInteger(this.endValue)) {
            currentValue = Math.round(this.cubicOut(progress) * (this.endValue - this.startValue) + this.startValue);
        } else {
            const decimalPlaces = this.endValue.toString().split('.')[1]?.length || 0;
            currentValue = (this.cubicOut(progress) * (this.endValue - this.startValue) + this.startValue).toFixed(decimalPlaces);
        }

        this.$el.textContent = currentValue.toString();

        if (progress < 1) {
            requestAnimationFrame(this.update.bind(this));
        }
    },
    startCount() {
        this.endValue = parseFloat(this.$el.getAttribute('data-end-value'));
        if (this.endValue) {
            this.startTime = performance.now();
            requestAnimationFrame(this.update.bind(this));
        }
    },
    init() {
        // INFO: disabled in VES-705
        // this.$store.observers.addObserver(this.$el, this.startCount.bind(this));
    }
})
